import { cn } from 'utils/helpers';
import { CELL_BORDER, COLUMN_STYLE } from './quote-table.types';

export interface SummaryTotalRow {
	id: string;
	label: string;
	color: string;
	displayValue: string;
}

export interface QuoteSummaryTotalsProps {
	diffKeys?: Set<string>;
	spacerColSpan: number;
	testIdPrefix?: string;
	totals: SummaryTotalRow[];
	trailingColSpan?: number;
}

const DIFF_HIGHLIGHT = 'bg-blue-50 font-medium text-blue-900 ring-2 ring-inset ring-blue-300';

const QuoteSummaryTotals: React.FC<QuoteSummaryTotalsProps> = ({
	diffKeys,
	spacerColSpan,
	testIdPrefix = 'summary',
	totals,
	trailingColSpan = 0,
}) => {
	if (totals.length === 0) {
		return null;
	}

	return (
		<>
			{totals.map((total) => {
				const isDiff = diffKeys?.has(`total.${total.id}`) ?? false;

				return (
					<tr key={total.id}>
						<td
							colSpan={spacerColSpan}
							className="h-[48px] border-none"
							style={{ background: '#F9FAFB' }}
						/>
						<td
							className={cn(CELL_BORDER, 'bg-gray-utility-100 px-4 py-2')}
							style={{ color: '#D0D5DD' }}
						>
							<div
								className="font-roboto font-medium"
								style={{ fontSize: '12px', color: total.color }}
							>
								{total.label}
							</div>
						</td>
						<td
							className={cn(
								CELL_BORDER,
								COLUMN_STYLE,
								'text-right pr-4',
								isDiff ? DIFF_HIGHLIGHT : 'bg-gray-utility-100'
							)}
							style={isDiff ? undefined : { color: '#333' }}
							data-testid={`${testIdPrefix}-total-${total.id}`}
						>
							{total.displayValue}
						</td>
						{trailingColSpan > 0 && (
							<td
								colSpan={trailingColSpan}
								className="h-[48px] border-none"
								style={{ background: '#F9FAFB' }}
							/>
						)}
					</tr>
				);
			})}
		</>
	);
};

export { QuoteSummaryTotals };
